<template>
  <learn-layout />
</template>

<script>
import LearnLayout from "@/components/LearnLayout.vue";

export default {
  name: "Learn",
  components: {LearnLayout},
  beforeMount() {
    this.$router.replace('/learn/branding')
  }
}
</script>

<style>

.embed-youtube {
  position: relative;
  padding-bottom: 56.25%; /* - 16:9 aspect ratio (most common) */
  /* padding-bottom: 62.5%; - 16:10 aspect ratio */
  /* padding-bottom: 75%; - 4:3 aspect ratio */
  padding-top: 30px;
  height: 0;
  overflow: hidden;
}

.embed-youtube iframe,
.embed-youtube object,
.embed-youtube embed {
  border: 0;
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
}

</style>